import styled from 'styled-components';

export const ListWrapper = styled.div`
  display: flex;
  padding: 20px;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background: rgba(0, 0, 0, 0.04);
`;

export const SwitchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
